const createImgsCallback = (src: string) => {
    const elem = document.createElement('img');
    elem.src = src + `&t=${new Date().getTime()}`;
    elem.style.display = 'none';
    document.body.appendChild(elem);
};

// 进入页面时触发
export const createImgsCallbackPage = () => {
    createImgsCallback('https://arttrk.com/pixel/?ad_log=referer&action=content&pixid=33f2c3a6-40eb-4203-9a6c-c8b7d4d64013');
};

// Learn More
export const createImgsCallbackLearnMore = () => {
    createImgsCallback('https://arttrk.com/pixel/?ad_log=referer&action=misc&pixid=33f2c3a6-40eb-4203-9a6c-c8b7d4d64013');
};

// Buy
export const createImgsCallbackBuy = () => {
    createImgsCallback('https://arttrk.com/pixel/?ad_log=referer&action=lead&pixid=33f2c3a6-40eb-4203-9a6c-c8b7d4d64013');
};